import React from "react";

export const FooterLogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({...props}) => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.6652 18.6703L31.6652 18.6703C31.778 18.2491 32.0244 17.7508 32.2143 17.4631C33.5797 14.8947 36.7123 14.1542 39.1472 15.5966C41.5821 17.039 42.4562 20.0946 41.0138 22.5295C40.7674 23.0277 40.444 23.3925 40.1206 23.7572L40.1205 23.7573C39.7971 24.122 39.3966 24.3533 38.996 24.5845C35.4477 26.4551 32.439 29.2603 30.2932 32.6353C29.0614 35.1266 28.2508 37.7308 27.9384 40.5813L27.553 39.9138C27.2446 39.3797 26.5922 38.8664 26.0169 38.4865C25.6907 38.2298 25.3311 37.9924 24.9715 37.7549C24.6119 37.5175 24.2523 37.2801 23.9261 37.0234C25.9081 35.5231 27.6588 33.6222 28.9113 31.475C30.7693 27.9101 31.708 23.9859 31.5372 19.9902C31.4395 19.5126 31.5523 19.0914 31.6652 18.6703ZM30.2171 19.8623L30.3245 18.1983C30.4373 17.7771 30.5502 17.3559 30.8736 16.9911C28.3163 18.1116 25.5277 18.8315 22.6978 18.8632C20.5561 18.8536 18.3167 18.3665 16.2672 17.5916C14.6389 16.9296 13.0106 16.2676 11.4387 15.395C11.3052 15.3289 11.1869 15.267 11.077 15.2095L11.077 15.2095C10.7767 15.0523 10.54 14.9284 10.2316 14.8458C9.81044 14.7329 9.38926 14.6201 8.91165 14.7178C6.08177 14.7495 3.66347 17.0358 3.6952 19.8657C3.72692 22.6956 5.9361 24.9804 8.76599 24.9486C9.66478 24.9638 10.5429 24.6348 11.344 24.1723C14.7381 22.0347 18.749 20.9651 22.7447 20.7943C25.174 20.9938 27.5469 21.404 29.8841 22.3688C29.9763 21.6035 30.0685 20.8382 30.2171 19.8623ZM27.5956 45.2295C27.9342 43.966 27.7745 42.4561 27.1578 41.388L26.6954 40.5869C26.2535 40.13 25.8888 39.8065 25.3134 39.4267C21.7485 37.5686 18.7534 34.8475 16.6157 31.4533C15.3824 29.3172 14.6832 26.8727 14.328 24.4076C14.0094 24.5915 13.6733 24.745 13.3219 24.9055L13.3218 24.9056C12.9369 25.0814 12.5335 25.2656 12.1148 25.5074C11.3137 25.9699 10.225 26.2424 9.40326 26.3608C11.7817 28.0138 13.6262 29.9752 15.0907 32.5118C16.9613 36.0602 17.8203 40.0146 17.7805 43.9538C17.7447 44.5085 17.9195 45.1196 18.0943 45.7308L18.5568 46.5318C19.9443 48.935 23.2367 49.7043 25.5627 48.1833C26.4202 47.5103 27.2571 46.4931 27.5956 45.2295Z"
        fill="#303030"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          x="32.9545"
          y="0.045517"
          width="38"
          height="38"
          transform="rotate(60 32.9545 0.045517)"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
